import {
  CourseCreate,
  CourseEdit,
  CourseList,
  CourseShow
} from 'pages/courses';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'courses',
  label: 'Cursos avulsos',
  list: CourseList,
  show: CourseShow,
  edit: CourseEdit,
  create: CourseCreate,
  actions: ['list', 'show', 'edit', 'create'],
  parentName: 'course_creation'
};

export default generateResources(resource);
